import {publicUserInfoShape} from '_app/shapes';

const AdvisorInfo = ({userInfo}) => (
	<div>
		<strong>{userInfo.displayName}</strong>
		{userInfo.fullAddressHtml && (
			<p dangerouslySetInnerHTML={{
				__html: userInfo.fullAddressHtml
			}}
			/>
		)}
		{userInfo.businessPhone && (<p>Office: {userInfo.businessPhone}</p>)}
		{userInfo.cellPhone && (<p>Mobile: {userInfo.cellPhone}</p>)}
		<p><a href={`mailto:${userInfo.email}`}>{userInfo.email}</a></p>
		<p><a href={userInfo.websiteUrl} target="_blank">{userInfo.websiteUrl}</a></p>
	</div>
);

AdvisorInfo.propTypes = {
	userInfo: publicUserInfoShape
};

export default AdvisorInfo;